<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel profile-panel profile-metrics">
                <template v-if="hasAthletics || hasPerformances">
                    <edit-button modal-target="editStats"/>
                    <h3 class="text-center tw-mb-5">{{$t('wi.stats')}}</h3>
                    <template v-if="hasAthletics">
                        <h5 class="tw-mb-4">{{$t('wi.athletic')}}</h5>
                        <div class="block-grid-md-4 block-grid-sm-4 block-grid-xs-2">
                            <div class="stat-container" v-for="stat in athletics">
                                <div class="stat stat-left" :class="{'highlight': stat.highlighted}">
                                    <i class="fas fa-star pull-right"></i>
                                    <span class="stat-name" v-text="stat.name"></span><br>
                                    <span class="small-stat" v-text="stat.value"></span>
                                    <span class="text-muted stat-unit" v-text="stat.unit"></span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="hasPerformances">
                        <h5 class="clearfix mg-top-40 tw-mb-4">{{ $t('wi.performance') }}</h5>
                        <div class="block-grid-md-4 block-grid-sm-4 block-grid-xs-2">
                            <div class="stat-container" v-for="stat in performances">
                                <div class="stat stat-left" :class="{'highlight': stat.highlighted}">
                                    <i class="fas fa-star pull-right"></i>
                                    <span class="stat-name" v-text="stat.name"></span><br>
                                    <span class="small-stat" v-text="stat.value"></span>
                                    <span class="text-muted stat-unit" v-text="stat.unit"></span>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <empty-state
                        v-else
                        :title="$t('wi.stats')"
                        :description="$t('wi.add_any_other_relevant_statistics')"
                        :button="{caption: $t('wi.add_more_stats')}"
                        modalTarget='editStats'
                />
            </div>
        </div>
    </div>

</template>

<script>
    import EditButton from '../VisualElements/EditButton';
    import EmptyState from '../EmptyState';
    import {mapGetters} from 'vuex';

    export default {
        name: "Stats",
        components: {
            EditButton,
            EmptyState
        },
        computed: {
            ...mapGetters({
                statsAthleticsData: 'player-profile/statsAthletics',
                statsPerformancesData: 'player-profile/statsPerformances'
            }),
            athletics() {
                return this.hasAthletics ? this.statsAthleticsData.metas.map(meta => meta.value) : [];
            },
            performances() {
                return this.hasPerformances ? this.statsPerformancesData.metas.map(meta => meta.value) : [];
            },
            hasAthletics() {
                return this.statsAthleticsData !== null && this.statsAthleticsData.metas.length > 0;
            },
            hasPerformances() {
                return this.statsPerformancesData !== null && this.statsPerformancesData.metas.length > 0;
            },
        }
    }
</script>

